import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 45 45",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-secondary",
			d: "M25.4 11.8l7.4-5.2c.8-.6.9-1.8.2-2.5s-1.9-.6-2.5.2l-5.1 7.5z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-secondary",
			d: "M25.4 33.1l7.4 5.2c.8.6.9 1.8.2 2.5s-1.9.6-2.5-.2l-5.1-7.5z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-primary",
			d: "M22.5 44.9H0V27.2l5.3-4.8L0 17.7V0h22.5v44.9zm-20-2.5H20V2.5H2.5v14.1L9 22.5l-6.5 5.9v14z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-primary",
			d: "M44.9 34.9l-19.5-5.5c-3.2-.9-5.2-3.6-5.2-6.9 0-3.3 2.1-6 5.2-6.9l19.5-5.5v24.8zM26.2 27l16.3 4.6V13.4L26.2 18c-2.5.7-3.4 2.9-3.4 4.5s.9 3.8 3.4 4.5z"
		})
	]
});
export default SvgIcon;
